<template>
  <div class="bg-white">
    <el-row class="pt-1">
      <el-col>
        <el-form
          class="text-right"
          :inline="true"
          @submit.native.prevent="fetch(1)"
          size="small"
        >
          <el-form-item>
            <!-- <el-input
              v-model="pager.search"
              placeholder="Search..."
              clearable
            ></el-input> -->
            <el-autocomplete
              v-model="pager.search"
              :fetch-suggestions="querySearch"
            >
              <el-select
                v-model="pager.search_by"
                slot="prepend"
                placeholder="Select"
                label="Select"
                @change="fetchList"
              >
                <el-option value="supplier" label="Supplier"></el-option>
                <el-option value="batch" label="Batch Number"></el-option>
                <el-option value="po" label="P.O. Number"></el-option>
              </el-select>
            </el-autocomplete>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetch(1)">Search</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-table :data="list.data" ref="stockList" v-loading="isLoading">
      <el-table-column label="Actions" width="100">
        <template slot-scope="scope">
          <router-link
            class="el-button el-button--primary el-button--small is-circle"
            :to="{
              name: 'batch_info',
              params: { id: scope.row.id },
              query: { tab: 2 }
            }"
            title="View batch information"
            ><i class="el-icon-folder-opened"></i>
          </router-link>
          <!-- <el-button size="small" type="primary"  icon="el-icon-folder-opened" circle></el-button> -->
          <!-- <el-button
            size="small"
            type="danger"
            icon="el-icon-delete"
            @click="itemDelete(scope.row.id)"
            title="Delete supplier"
            circle
          ></el-button> -->
        </template>
      </el-table-column>
      <el-table-column label="Supplier" prop="fields.supplier_name" />
      <el-table-column label="Batch Number" prop="batch_no" />
      <el-table-column label="P.O. Number" prop="fields.po_no" />
      <el-table-column label="Date Received" prop="fields.date_received" />
      <el-table-column label="Status">
        <template slot-scope="scope">
          <span v-if="scope.row.status">Complete</span>
          <span v-else>Incomplete</span>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-show="list.data.length"
      class="pt-1 pb-1"
      background
      layout="prev, pager, next"
      :total="list.paging.total"
      :page-size="pager.limit"
      :current-page="parseInt(list.paging.cur_page)"
      @current-change="fetch"
    ></el-pagination>
  </div>
</template>

<script>
import Supplier from "@/models/Supplier";
import PurchaseOrder from "@/models/PurchaseOrder";
import api from "@/api";
export default {
  name: "inventory_list",
  computed: {
    list() {
      return this.$store.getters["stockin/list"];
    }
  },
  data() {
    return {
      isLoading: false,
      pager: {
        limit: 25,
        search: "",
        search_by: "",
        page: 1
      },
      supplier: [],
      po: [],
      batch: []
    };
  },
  methods: {
    fetch(page) {
      this.isLoading = true;
      this.pager.page = page;
      var params = { ...this.pager, list: 1 };
      // if (!this.pager.search) delete params.search;
      this.$store.dispatch("stockin/getList", params).then(() => {
        this.isLoading = false;
      });
    },
    fetchList() {
      this.pager.search = "";
      if (this.pager.search_by == "supplier" && this.supplier.length <= 0) {
        Supplier.getGlossary().then(list => {
          if (list) {
            this.supplier = [];
            for (let s of list) {
              this.supplier.push({
                value: s.name,
                id: s.id
              });
            }
          }
        });
      } else if (this.pager.search_by == "po" && this.po.length <= 0) {
        PurchaseOrder.getList({
          limit: 999999999,
          status: "all"
        }).then(list => {
          if (list) {
            this.po = [];
            for (let p of list.data) {
              this.po.push({
                value: p.po_no
              });
            }
          }
        });
      } else if (this.pager.search_by == "batch" && this.batch.length <= 0) {
        api.get(`api/v1/inventory/batches/`, { all: 1 }).then(resp => {
          if (resp && resp.status == 200) {
            this.batch = [];
            for (let b of resp.data.data) {
              this.batch.push({
                value: b.batch_no
              });
            }
          }
        });
      }
    },
    querySearch(queryString, cb) {
      let list = [];
      if (this.pager.search_by == "supplier") {
        list = queryString
          ? this.supplier.filter(this.createFilter(queryString))
          : this.supplier;
      } else if (this.pager.search_by == "po") {
        list = queryString
          ? this.po.filter(this.createFilter(queryString))
          : this.po;
      } else if (this.pager.search_by == "batch") {
        list = queryString
          ? this.batch.filter(this.createFilter(queryString))
          : this.batch;
      }
      cb(list);
    },
    createFilter(queryString) {
      return item => {
        return (
          item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    }
  },
  mounted() {
    this.fetch(1);
  }
};
</script>

<style lang="css" scoped></style>
